import { createApi } from '@reduxjs/toolkit/query/react'
import { authenticatedBaseQuery } from './baseQuery'

// Define a service using a base URL and expected endpoints
export const orderApi = createApi({
  reducerPath: 'orderApi',
  baseQuery: authenticatedBaseQuery,
  tagTypes: ['Order'],
  endpoints: (builder) => ({
    getAllOrder: builder.query({
      query: () => {
        return {
          url: 'order/getAllorder/',
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
          }
        }
      },
      providesTags: ['Order'],
    }),
    updateOrder: builder.mutation({
      query:(order) => {
        const {id, ...rest} = order
        return {
          url: `order/update/${id}`,
          method: 'PUT',
          body: rest,
          headers: {
            'Content-type': 'application/json',
          }
        }
      },
      invalidatesTags: ['Order'],
    }),
    detaildOrder: builder.query({
      query: (id) => {
        return {
          url: `order/getDetaildOrder/${id}`,
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
          }
        }},
      providesTags: ['Order'],
    }),
    orderedProducts: builder.query({
      query: (id) => {
        return {
          url: `order/orderdProducts/${id}`,
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
          }
        }}
    }),
    deleteOrder: builder.mutation({
      query:(order) => {
        return {
          url: `order/delete/${order}`,
          method: 'DELETE',
          body:order,
          headers: {
            'Content-type': 'application/json',
          }
        }
      },
      invalidatesTags: ['Order'],
    }),
    updatePayment: builder.mutation({
      query:(order) => {
        const {id, ...rest} = order
        return {
          url: `order/paymentUpdate/${id}`,
          method: 'PUT',
          body: rest,
          headers: {
            'Content-type': 'application/json',
          }
        }
      },
      invalidatesTags: ['Order'],
    }),
  }),
})

export const { useGetAllOrderQuery, useUpdateOrderMutation ,useDeleteOrderMutation,
  useDetaildOrderQuery ,useOrderedProductsQuery ,useUpdatePaymentMutation} = orderApi
